import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Group, GroupData } from '../data/group';
import { MessageHandlerService } from "../../services/message-handler.service"

@Injectable()
export class GroupService extends GroupData {


  emitter: EventEmitter<any> = new EventEmitter();
  api: string;
  apiForm: string;
  header: any;
  constructor(private http: HttpClient, private messageHandler: MessageHandlerService) {
    super();
    this.api = environment.apiUrl;
  }


  subscribeToUpdate() {
    return this.emitter;
  }

  updateListeners() {
    this.emitter.emit("");
  }

  async getGroups() {
    try {
      let response = await this.http.get(this.api + "groups").toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }




  async createGroup(Group: Group) {
    try {
      let response = await this.http.post(this.api + "group", Group).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }





  async deleteGroup(id: string) {
    try {
      let response = <Group>await this.http.delete(this.api + "group/" + id).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async  sslCname(id: string) {
    try {
      let response = <Group>await this.http.get(this.api + "sslCname/" + id).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }

  async verifyDNS(id: string) {
    try {
      let response = <Group>await this.http.get(this.api + "verifyDNS/" + id).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }


  
  async getGroupId(id: string) {
    try {
      let response = <Group>await this.http.get(this.api + "group/" + id).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }


  async editGroup(Group: Group, id: string) {
    try {
      let response = <Group>await this.http.put(this.api + "group/" + id, Group).toPromise();
      return response

    } catch (e) {

      this.messageHandler.error(e);
      throw new Error(e.error.message)

    }
  }



}
